import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/company/base-testfy/new',
  title: 'Editar Testfy Base',
  endpoint: '/app/company',
}
